var path = 'dashboard/states/default-state-controller.tpl.html';
var html = " <md-select class=default-state-controller ng-show=vm.displayStateSelection() aria-label=\"{{ 'dashboard.state' | translate }}\" ng-model=vm.stateObject[0].id> <md-option ng-repeat=\"(stateId, state) in vm.states\" ng-value=stateId> {{vm.getStateName(stateId, state)}} </md-option> </md-select> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/states/default-state-controller.tpl.html
// module id = 1467
// module chunks = 1